export default "__VITE_ASSET__BiUZBCar__"